exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".unverified-user-alert-component .alert {\n  position: fixed !important;\n  width: 100% !important;\n  z-index: 1000 !important;\n  border: none !important;\n  color: #ffffff !important;\n  background-color: #dc3545 !important;\n  -webkit-transition: all 0.2s ease;\n}", ""]);

// exports
